import React from 'react';
import { Box, Button, Grid, Stack, TextField, Typography } from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import RestoreIcon from '@mui/icons-material/Restore';

import Panel from '../ui/Panel';
import { radius } from '../../theme/tokens';

/**
 * Per-category colour overrides. Colours are persisted to local storage by the
 * parent via utils/colors, so this component only reports changes upward.
 */
const CategoryColorsSection = ({ colors, onColorChange, onSave, onReset }) => (
  <Panel
    title="Category Colors"
    subtitle="Customize the colors used for different ticket categories."
    action={
      <Stack direction="row" spacing={1}>
        <Button size="small" variant="outlined" startIcon={<RestoreIcon />} onClick={onReset}>
          Reset
        </Button>
        <Button size="small" variant="contained" startIcon={<ColorLensIcon />} onClick={onSave}>
          Save
        </Button>
      </Stack>
    }
  >
    <Grid container spacing={2}>
      {Object.entries(colors).map(([category, color]) => (
        <Grid key={category} size={{ xs: 12, sm: 6, md: 4 }}>
          <Box
            sx={{
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: `${radius.md}px`,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
              <Box
                sx={{ width: 14, height: 14, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }}
              />
              <Typography variant="subtitle2" noWrap>
                {category}
              </Typography>
            </Stack>
            <TextField
              fullWidth
              size="small"
              type="color"
              value={color}
              onChange={(e) => onColorChange(category, e.target.value)}
            />
          </Box>
        </Grid>
      ))}
    </Grid>
  </Panel>
);

export default CategoryColorsSection;
